<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const i18n = useI18n()

const christmasUspLists = [
    {
        url: i18n.t('uspChristmas.benefit1.url'),
        icon: i18n.t('uspChristmas.benefit1.icon'),
        title: i18n.t('uspChristmas.benefit1.title'),
        external: i18n.t('uspChristmas.benefit4.external'),
    },
    {
        url: i18n.t('uspChristmas.benefit2.url'),
        icon: i18n.t('uspChristmas.benefit2.icon'),
        title: i18n.t('uspChristmas.benefit2.title'),
        external: i18n.t('uspChristmas.benefit4.external'),
    },
    {
        url: i18n.t('uspChristmas.benefit3.url'),
        icon: i18n.t('uspChristmas.benefit3.icon'),
        title: i18n.t('uspChristmas.benefit3.title'),
        external: i18n.t('uspChristmas.benefit4.external'),
    },
    {
        url: i18n.t('uspChristmas.benefit4.url'),
        icon: i18n.t('uspChristmas.benefit4.icon'),
        title: i18n.t('uspChristmas.benefit4.title'),
        external: i18n.t('uspChristmas.benefit4.external'),
    },
]
</script>

<template>
    <div class="benefitBoxes">
        <lazy-load-component :enabled="false" class="benefitBoxes__content" root-margin="0px 0px 0px 0px">
            <a
                v-for="(item, index) in christmasUspLists"
                :key="index"
                class="benefitBoxes__item"
                :href="item.url"
                :target="item.external === 'true' ? '_blank' : ''"
            >
                <div class="benefitBoxes__icon">
                    <img
                        :src="`/nuxt-assets/images/icons/usp/${item.icon}.svg`"
                        data-not-lazy
                        :alt="item.title.replace(/<[^>]*>?/gm, '')"
                        :width="52"
                        :height="52"
                    />
                </div>
                <span class="benefitBoxes__title" v-html="item.title"></span>
            </a>
        </lazy-load-component>
    </div>
</template>

<style scoped lang="scss">
.benefitBoxes {
    width: 100%;
    padding: 10px 15px;

    &--top {
        margin-top: -30px;
        position: relative;
        z-index: 3;
        margin-bottom: 2em;

        @media (min-width: $max-width-container-inside) {
            margin-top: -40px;
        }
    }

    &__content {
        width: calc(100% + 2 * $padding-container-inside-mobile);
        margin-left: -$padding-container-inside-mobile;
        padding-left: $padding-container-inside-mobile;
        display: grid;
        grid-template-columns: repeat(4, 1fr);
        overflow-x: auto;
        padding-top: 10px;
        padding-bottom: 10px;

        @include screen-sm {
            width: calc(100% + (2 * $padding-container-inside));
            margin-left: -$padding-container-inside;
            padding-left: $padding-container-inside;
        }

        @media (min-width: $max-width-container-inside) {
            width: 100%;
            max-width: $max-width-container-inside;
            padding-left: 0;
            margin: 0 auto;
            justify-content: space-between;
            overflow: visible;
        }
    }

    &__item {
        display: flex;
        align-items: center;
        min-width: 252px;
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        box-shadow: $box-shadow;
        margin-right: $padding-container-inside-mobile;
        background-color: $color-white;
        padding: 1.25rem;

        &:hover {
            @include screen-lg {
                box-shadow: $box-shadow-hover;
            }
        }
    }

    &__icon {
        width: 42px;
        height: 42px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    &__title {
        color: $color-dark;
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        margin: 0 0 0 10px;
        display: block;
        text-align: left;
        position: relative;
        z-index: 2;

        @include screen-lg {
            font-size: 16px;
            line-height: 21px;
        }
    }
}
</style>
